import { useGlobalKey, useKey } from '@patchbay/ui'
import { useNavigate } from '@tanstack/react-router'
import { useMe } from '../features/auth/session'
import { canSeeProfit } from '../features/profit/api'
import { canSeeProjects } from '../features/projects/api'
import { bindOf, bindOptions, KEYS } from '../lib/keys'
import { useWorkspace } from '../lib/workspace'

/** Global chords (scope §5.0). Screen keys are bound by the screen that owns them. */
export function GlobalKeys() {
  const ws = useWorkspace()
  const navigate = useNavigate()
  const me = useMe()
  const profit = canSeeProfit(me?.role)
  const projects = canSeeProjects(me?.role) && me?.ui_mode !== 'simple'
  useGlobalKey(KEYS.palette.keys, () => ws.setPaletteOpen(!ws.paletteOpen), [ws.paletteOpen])
  useKey(bindOf(KEYS.search), () => ws.setPaletteOpen(true), bindOptions(KEYS.search), [ws])
  useKey(bindOf(KEYS.keySheet), () => ws.setKeySheetOpen(true), bindOptions(KEYS.keySheet), [ws])
  useKey(KEYS.newCase.keys, () => ws.setNewCaseOpen(true), {}, [ws])
  useKey(KEYS.goHome.keys, () => navigate({ to: '/' }), {}, [navigate])
  useKey(KEYS.goQueue.keys, () => navigate({ to: '/queue/$lane', params: { lane: 'needs-us-now' } }), {}, [navigate])
  useKey(KEYS.goDispatch.keys, () => navigate({ to: '/schedule' }), {}, [navigate])
  useKey(KEYS.goLedger.keys, () => navigate({ to: '/ledger' }), {}, [navigate])
  useKey(KEYS.goBilling.keys, () => navigate({ to: '/billing' }), {}, [navigate])
  useKey(KEYS.goKnowledge.keys, () => navigate({ to: '/knowledge' }), {}, [navigate])
  useKey(KEYS.goReports.keys, () => navigate({ to: '/reports' }), {}, [navigate])
  useKey(KEYS.goProjects.keys, () => projects && navigate({ to: '/projects' }), {}, [navigate, projects])
  // Manager and billing only; for anyone else the chord does nothing (the route would send them home anyway).
  useKey(KEYS.goProfit.keys, () => profit && navigate({ to: '/profit' }), {}, [navigate, profit])
  useKey(KEYS.toggleRail.keys, () => ws.toggleRail(), {}, [ws])
  useKey(KEYS.rileyFull.keys, () => ws.setRileyMode(ws.rileyMode === 'full' ? 'rail' : 'full'), {}, [ws])
  return null
}
